import React, { useContext } from 'react';

const TemplatesContext = React.createContext({});

const TemplatesProvider = (props) => {
  return (
    <TemplatesContext.Provider
      {...props}
    />
  )
};

export const useTemplates = () => {
  const context = useContext(TemplatesContext);

  if (context === undefined) {
    throw new Error("useTemplates must be used within a TemplatesProvider");
  }

  return context;
};

export default TemplatesProvider;
